import useLocalStore from '../../../hooks/useLocalStore';
import FJProductToVideo from './FJProductToVideo';
import { useSelector } from 'react-redux';

const FJProductToVideoContainer = () => {
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);
    useLocalStore();

    return <FJProductToVideo textToVideoStep={textToVideoStep} />;
};

export default FJProductToVideoContainer;
